export default __webpack_public_path__ + "static/media/technologists.89b4fcb0.jpg";